// extracted by mini-css-extract-plugin
module.exports = {"text":"dece2e673c--text--h8euP"};